module.exports = __webpack_public_path__ + "img/sankaku_55_red.e9322e08.png";